module.exports = __webpack_public_path__ + "img/13.6699f93e.jpg";